<template>
    <div v-if="isMobile">
        <div class="hkfc-bracket-tabs__mobile has-space">
            <div class="hkfc-bracket-tabs__selected-name" @click="toggleTabsMobile($event)">
                <div>{{ $t(currentTab.name) }}</div>
                <div class="hkfc-bracket-tabs__selected-arrow" :class="{'selected' : isShowBracketMobileOptions}"><img src="../../../static/images/icons/icon_arrow_down_white.png"></div>
            </div>
            <div class="hkfc-bracket-tabs__mobile-options__wrapper" :class="{ 'hkfc-bracket-option__selected' : isShowBracketMobileOptions}" >
                <div class="hkfc-bracket-tabs__mobile-options " :class="{'hkfc-mobile-tabs-bracket__selected': o.selected }" v-for="(o, index) in tabs" :key="index" @click="selectTabs(o)">
                    <div>{{ $t(o.name) }}</div>
                    <div v-show="o.selected"><img src="../../../static/images/icons/icon_tick_selected.png"></div>
                </div>
            </div>
        </div>
        <BracketMobile ref="bracketMobileRef"></BracketMobile> 
    </div>
    <div v-else>
        <div class="nav-pill__wrapper hkfc-bracket__tabs">
            <div class="nav-pill" 
                v-for="(o, index) in tabs" 
                :key="index" 
                :class="{'selected': o.selected}"
                @click="selectTabs(o)">
                {{ $t(o.name) }}
            </div>
        </div>
        <div class="bracket-container">
            <img :src="require(`../../../static/images/hkfc/${currentTab.bg}.png`)">
            
            <div class="bracket-card__center__wrapper">
                <div class="bracket-card__center-title__wrapper">
                    <div class="bracket-card__center-title">{{ $t(currentTab.name) }}</div>
                    <div class="bracket-card__center-title">{{ $t('BRACKET') }}</div>
                </div>
                <div class="bracket-card__title-prize" :class="[currentLocale === 'vn' ? 'bracket-card__title-final-longer' : 'bracket-card__title-final']">{{ $t('GRAND_FINAL') }}</div>
            </div>

            <div :class="`${currentTab.key}`">
                <div class="bracket-card" :class="`bracket-card__${entry.sequenceId}`"  v-for="(entry, index) in knockoutList" :key="index">	
                    <div class="bracket-card__status">{{ formatDateTime(entry) }}</div>	
                    <div class="bracket-card__team-body">
                        <div class="bracket-card__team-wrapper">
                            <img class="bracket-card__team-icon" 
                                :src="entry.homeId  ? `${imageUrlPrefix}/${entry.homeLogo}` : require('../../../static/images/icons/icon_bracket_default.png') "
                            >
                            <div class="bracket-card__team-name">
                                <div class="bracket-card__team-name__width" :title="formatTeamName(entry,'home')" :class="{'short-width' : verfiyIsPenaltyWin(entry, 'home')}">{{ formatTeamName(entry,'home') }}</div>
                                <div v-if="verfiyIsPenaltyWin(entry, 'home')" class="bracket-card__team__penalty">P</div>
                            </div>
                        </div>
                        <div class="knockout-card__team__score">
                            <div>{{ formatTeamScore(entry, 'home') }}</div>
                            <div class="knockout-card__team-score-divider__wrapper"  v-if="entry.homePenaltyScore">
                                <div class="knockout-card__team__score-divider"></div>
                                <div class="knockout-card__team__score-only">{{ entry.homePenaltyScore }}</div>
                            </div>
                        </div>   
                    </div>	
                    <div class="bracket-card__team-body">
                        <div class="bracket-card__team-wrapper">
                            <img class="bracket-card__team-icon" 
                                :src="entry.awayId  ? `${imageUrlPrefix}/${entry.awayLogo}` : require('../../../static/images/icons/icon_bracket_default.png') "
                            >		
                             <div class="bracket-card__team-name">
                                <div class="bracket-card__team-name__width"  :title="formatTeamName(entry,'away')"  :class="{'short-width' : verfiyIsPenaltyWin(entry, 'away')}">{{ formatTeamName(entry,'away') }}</div>
                                <div v-if="verfiyIsPenaltyWin(entry, 'away')" class="bracket-card__team__penalty">P</div>
                            </div>			
                        </div>
                        <div class="knockout-card__team__score">
                                <div>{{ formatTeamScore(entry, 'away') }}</div>
                                <div class="knockout-card__team-score-divider__wrapper" v-if="entry.homePenaltyScore">
                                    <div class="knockout-card__team__score-only">{{ entry.awayPenaltyScore }}</div>
                                </div>
                            </div>
                        <!-- <div class="bracket-card__team-score__wrapper">
                            <div class="bracket-card__team-score">{{ formatTeamScore(entry, 'away') }}</div>
                            <div class="knockout-card__team-score-divider__wrapper" v-if="entry.homePenaltyScore">
                                <div class="knockout-card__team__score-divider"></div>
                                <div class="knockout-card__team__score-only">{{ entry.awayPenaltyScore }}</div>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters,mapActions } from 'vuex'
import moment from 'moment';
import BracketMobile from './BracketMobile.vue'
import config from '@/js/config.js';

const defaultTeamName = 'TBD';
const defaultTeamScore = "-";
const defaultTeamLogo = "../../../static/images/world_cup_default_team.png";

export default {
    components:{  
		BracketMobile,    
    },
    data() {
        return {
            imageUrlPrefix: config.s3ImgUrl,
            cnLocaleList: config.cnLocaleList,
            tabs: [
                {
                    name: "MAIN_TOURNAMENT_CUP",
                    mobileName: "MAIN_TOURNAMENT",
                    mobileType: "CUP",
                    key: "main-tournament-cup",
                    bg: "bracket-bg-1",
                    subId: "2",
                    knockoutType: "C",
                    selected: false
                },
                {
                    name: "MAIN_TOURNAMENT_PLATE",
                    mobileName: "MAIN_TOURNAMENT",
                    mobileType: "PLATE",
                    key: "main-tournament-plate",
                    bg: "bracket-bg-1",
                    subId: "2",
                    knockoutType: "P",
                    selected: false
                },
                {
                    name: "MAIN_TOURNAMENT_SHIELD",
                    mobileType: "SHIELD",
                    mobileName: "MAIN_TOURNAMENT",
                    key: "main-tournament-shield",
                    bg: "bracket-bg-2",
                    subId: "2",
                    knockoutType: "S",
                    selected: false
                },
                {
                    name: "MASTERS_TOURNAMENT_CUP",
                    mobileType: "CUP",
                    mobileName: "MASTERS_TOURNAMENT",
                    key: "masters-tournament-cup",
                    bg: "bracket-bg-2",
                    subId: "1",
                    knockoutType: "C",
                    selected: false
                },
                {
                    name: "MASTERS_TOURNAMENT_PLATE",
                    mobileType: "PLATE",
                    mobileName: "MASTERS_TOURNAMENT",
                    key: "masters-tournament-plate",
                    bg: "bracket-bg-2",
                    subId: "1",
                    knockoutType: "P",
                    selected: false
                }
            ],
            isShowBracketMobileOptions: false,
            knockoutList: [],
            currentTab: {
                name: "",
                bg: "bracket-bg-1"
            }
        }
    },
    mounted() {
        this.selectTabs(this.tabs[0]);
        document.addEventListener('click', this.handleDocumentClickEvent);
    },
    computed: {
        ...mapGetters([
            "isMobile",
            "currentLocale",
        ]),
    },
    methods: {
        ...mapActions([
			"getHKFCMatchKnockout",
		]),

        async getHKFCMatchKnockoutData(o) {
            let params = {
                leagueId: 1,
                subId: o.subId,
                knockoutType: o.knockoutType,
                timeZone: this.$tools.getCurrentTimeZone(),
            }
            const result = await this.getHKFCMatchKnockout(params);
            this.knockoutList = result.result.matchKnockouts;
        },
        selectTabs(o) {
            this.tabs.forEach(element => {
                element.selected = false;
            });
            this.currentTab = o;
            o.selected = !o.selected;

        

            if (this.isMobile) {
                this.isShowBracketMobileOptions = false;
                this.$refs.bracketMobileRef.gettHKFCKnockoutData(o);
            } else {
                this.getHKFCMatchKnockoutData(o);
            }
        },
        toggleTabsMobile(e) {
            this.isShowBracketMobileOptions = !this.isShowBracketMobileOptions;
            e.stopPropagation();
        },
		formatDateTime(entry) {
            if (entry.matchStatus) {
                return entry.matchStatus             
            } else {
                const momentTime = moment(entry.matchTime);
                if (this.cnLocaleList.includes(this.currentLocale)) {
                    return momentTime.format('Do MMM, HH:mm ');
                } else {
                    return momentTime.format('D MMM, HH:mm ');
                }
            }
        },

		formatTeamName(entry, status) {
            if (status === 'home') {
                if (entry.homeId) {
                    return entry.homeName
                } else {
                    return defaultTeamName
                }
            } else {
                 if (entry.awayId) {
                    return entry.awayName
                } else {
                    return defaultTeamName
                }
            }
        },

        formatTeamScore(entry, status) {
            if (status === 'home') {
                if (entry.homeScore) {
                    return entry.homeScore
                } else {
                    return defaultTeamScore
                }
            } else {
                 if (entry.awayScore) {
                    return entry.awayScore
                } else {
                    return defaultTeamScore
                }
            } 
        },

		
        verfiyIsPenaltyWin(entry, status) {
            if (status === 'home') {
                if (entry.homePenaltyScore > entry.awayPenaltyScore) {
                    return true
                } else  {
                    return false
                }
            } else {
                if (entry.awayPenaltyScore > entry.homePenaltyScore) {
                    return true
                } else {
                    return false
                }
            }
        },

        handleDocumentClickEvent() {
            this.isShowBracketMobileOptions = false;
        }


    },
}
</script>

<style scoped>
    .hkfc-bracket__tabs{
        justify-content: center;
    }
    .bracket-container{
        position: relative;
    }
    .bracket-card{
        border-radius: 8px;
        background: #35454D;
        /* background: #98d9f9; */
        width: 152px;
        height: 80px;
        position: absolute;
        padding: 5px;
        box-sizing: border-box;
    }
    .bracket-card__status{
        color: #CFD9DE;
        font-size: 11px;
        margin-bottom: 5px;
    }

    .main-tournament-cup .bracket-card__51{
        top: 120px;
        left: 228px;
    }
    .main-tournament-cup .bracket-card__52{
        top: 120px;
        left: 820px;
    }
    .main-tournament-cup .bracket-card__53{
        top: 400px;
        left: 228px;
    }
    .main-tournament-cup .bracket-card__54{
        top: 400px;
        left: 820px;
    }

    .main-tournament-cup .bracket-card__62{
        top: 260px;
        left: 337px;
    }
    .main-tournament-cup .bracket-card__63{
        top: 260px;
        left: 712px;
    }
    .main-tournament-cup .bracket-card__67{
        top: 260px;
        left: 524px;
    }


    /* main plate */
    .main-tournament-plate .bracket-card__47{
        top: 120px;
        left: 228px;
    }
    .main-tournament-plate .bracket-card__48{
        top: 120px;
        left: 820px;
    }
    .main-tournament-plate .bracket-card__49{
        top: 400px;
        left: 228px;
    }
    .main-tournament-plate .bracket-card__50{
        top: 400px;
        left: 820px;
    }

    .main-tournament-plate .bracket-card__58{
        top: 260px;
        left: 337px;
    }
    .main-tournament-plate .bracket-card__59{
        top: 260px;
        left: 712px;
    }
    .main-tournament-plate .bracket-card__64{
        top: 260px;
        left: 524px;
    }

    /* main shield */
    .main-tournament-shield .bracket-card__60{
        top: 260px;
        left: 303px;
    }
    .main-tournament-shield .bracket-card__61{
        top: 260px;
        left: 743px;
    }
    .main-tournament-shield .bracket-card__65{
        top: 260px;
        left: 524px;
    }

    /* master cup */
    .masters-tournament-cup .bracket-card__55{
        top: 260px;
        left: 303px;
    }
    .masters-tournament-cup .bracket-card__56{
        top: 260px;
        left: 743px;
    }
    .masters-tournament-cup .bracket-card__66{
        top: 260px;
        left: 524px;
    }


    /* master plate */
    .masters-tournament-plate .bracket-card__45{
        top: 260px;
        left: 303px;
    }
    .masters-tournament-plate .bracket-card__46{
        top: 260px;
        left: 743px;
    }
    .masters-tournament-plate .bracket-card__57{
        top: 260px;
        left: 524px;
    }

    .bracket-card__team-body{
        display: flex;
        justify-content: space-between;
        font-size: 11px;
        color: #CFD9DE;
        margin-bottom: 9px;
    }
    .bracket-card__team-icon{
        margin-right: 3px;
        width: 15px;
    }
    .bracket-card__team-wrapper{
        display: flex;
        align-items: center;
    }
    .bracket-card__center-wrapper{
        position: absolute;
        top: 0;
        width: 100%;
        display: flex;
        justify-content: center;
    }
    .bracket-card__center-stripe{
        position: absolute;
        left: 369px;
        top: 0px;
    }
    .bracket-card__center-flower{
        position: absolute;
        object-fit: contain;
        top: 197px;
        left: 619px;
        z-index: -1;
    }
    .bracket-card__center-title{
        font-size: 36px;
        font-style: italic;
        font-family: var(--weight-700);
        -webkit-text-stroke: 2px white;
        text-shadow: 2px 2px 6px #ffffff40;
        color: transparent;
        text-align: center;
    }
    .bracket-card__center__wrapper{
        position: absolute;
        top: 0;
        width: 100%;
    }
    .bracket-card__center-title__wrapper{
        top: 3rem;
        position: absolute;
        width: 100%;
        text-align: center;
    }
    .bracket-card__title-prize{
        position: absolute;
        width: 152px;
        font-size: 22px;
        font-style: italic;
        font-family: var(--weight-700);
        text-align: center;
    }
    .bracket-card__title-champion{
        left: 32.5rem;
        top: 12rem;
    }
    .bracket-card__title-third{
        left: 32.5rem;
        top: 29rem;
    }
    .bracket-card__title-final{
        display: flex;
        justify-content: center;
        width: 100%;
        top: 14.3rem;
    }
    .bracket-card__title-final-longer {
        left: 32.5rem;
        top: 17rem;
    }
    .bracket-card__final{
        width: 152px;
        height: 34px;
        background: #35454D;
        position: absolute;
        top: 221px;
        left: 521px;
        padding: 8px;
        box-sizing: border-box;
        border-radius: 8px;
    }
    .bracket-card__team-name{
        display: flex;
        line-height: 18px;
    }
    .bracket-card__team-name__width{
        width: 102px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 10px;
        font-family: var(--weight-400);
	    letter-spacing: 0.2px;
    }
    .short-width{
        width: 72px;
    }
    .bracket-card__team__penalty{
        background-color: #5CD66C;
        border-radius: 0.25rem;
        font-size: 9px;
        height: 16px;
        width: 14px;
        text-align: center;
        margin-left: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #FFFFFF;
    }
    .knockout-card__team-score-divider__wrapper{
        display: flex;
        margin-left: 4px;
    }
    .knockout-card__team__score-divider{
        position: absolute;
        width: 1px;
        height: 44px;
        background-color: #4B616C;
    }
    .knockout-card__team-score-divider__wrapper{
        display: flex;
        margin-left: 4px;
    }
    .knockout-card__team__score-divider{
        position: absolute;
        width: 1px;
        height: 44px;
        background-color: #4B616C;
    }
    .knockout-card__team__score-only{
        width: 12px;
        text-align: right;
    }	
    .knockout-card__team__score {
        position: absolute;
        right: 9px;
        width: auto;
        line-height: 18px;
        color: #FFFFFF;
        display: flex;
    }


    /* mobile bracket */
    .hkfc-bracket-tabs__mobile{
        position: relative
    }
    .hkfc-bracket-tabs__mobile-options{
        padding: 10px 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .hkfc-bracket-tabs__mobile-options__wrapper{
        border-radius: 8px;
        background: #212B30;
        padding: 4px 0;
        margin-top: 4px;
        transform: scale(0);
        position: absolute;
        z-index: 201;
        width: 100%;
        transition: all .3s;
        transform-origin: 50% 0;
        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25), 0px 16px 16px rgba(0, 0, 0, 0.04), 0px 1px 1px rgba(0, 0, 0, 0.04), 0px 2px 2px rgba(0, 0, 0, 0.04), 0px 4px 4px rgba(0, 0, 0, 0.04), 0px 8px 8px rgba(0, 0, 0, 0.04);
    }
    .hkfc-mobile-tabs-bracket__selected{
        background: #4B616C;
    }
    .hkfc-bracket-option__selected{
        transform: scale(1);
    }
    .hkfc-bracket-tabs__selected-name{
        border-radius: 8px;
        border: 1px solid #4B616C;
        padding: 16px 12px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .hkfc-bracket-tabs__selected-arrow{
        transition: all .3s;
    }
    .hkfc-bracket-tabs__selected-name .selected{
        transform: rotate(180deg);
    }
</style>